/**
 * useOptimisticListingRowPatch — patches a single cached listing row
 * without waiting for a full refetch.
 *
 * A12 from listing-abstraction-opportunities.md
 *
 * Returns a stable callback that callers pass as onRowUpdate to inline
 * cell editors. On call it finds the updated row by id and replaces it
 * in the React Query cache entry.
 */
import { useCallback } from 'react';
export function useOptimisticListingRowPatch({ queryClient, queryKey, rowsKey = 'data' }) {
    return useCallback((updatedRow) => {
        queryClient.setQueryData(queryKey, (prev) => {
            var _a;
            if (!prev)
                return prev;
            const currentRows = (_a = prev[rowsKey]) !== null && _a !== void 0 ? _a : [];
            return Object.assign(Object.assign({}, prev), { [rowsKey]: currentRows.map((r) => (r.id === updatedRow.id ? updatedRow : r)) });
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [queryClient, JSON.stringify(queryKey), rowsKey]);
}
